import React,{useEffect} from 'react';
import { CSSTransition, SwitchTransition } from "react-transition-group";
import styled from 'styled-components';
import ListItem from './../elements/listItem';
import { connect } from 'react-redux';
import { AppState } from '../../store';
import { getCategory } from '../../store/categories/functions';
import { CONSTS } from '../elements/_constants';
type navigationProps = {
    className?: string,
    currentCategory: any,
    currentCategoryId: number,
    isSubCategoriesOpen: boolean
}
const SubCategoiresComponent = (props:navigationProps) => {
    return (
        <div className={props.className}>
            <SwitchTransition>
                <CSSTransition
                    key={props.currentCategory && props.currentCategory.id}
                    timeout={{ enter: 300, exit: 300 }}
                    classNames="fade"
                >
                    <div className="inside-sub-categories">
                        {
                            props.currentCategory && props.currentCategory.children.map(
                                (child: any,k: number)=>{
                                    return  <ListItem to={`/categories/${child.id}`} active={child.id == props.currentCategoryId} key={k}>
                                                {child.title}
                                            </ListItem>
                                }
                            )
                        }
                    </div>
                </CSSTransition>
            </SwitchTransition>
        </div>
    )
}

const SubCategoires = styled(SubCategoiresComponent)`
    ${props => props.isSubCategoriesOpen ? `
        width: 250px;
        @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
            width: calc(100vw - 65px);
        }
        opacity: 1;
    ` : `
        width: 0px;
        opacity: 0;
        `}
    transition: ease width .3s, ease opacity .35s;
    height: 100%;
    overflow: hidden;
    .inside-sub-categories {
        width: 250px;
        height: 100%;
        @media only screen and (max-width: ${CONSTS.responsiveSizes.small}) {
            width: calc(100vw - 65px);
        }
        overflow: auto;
        /* width */
        ::-webkit-scrollbar {
            width: 5px;
        }

        /* Track */
        ::-webkit-scrollbar-track {
            background: #f1f1f1;
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
            background: ${CONSTS.colors.primaryLight};
        }

        /* Handle on hover */
        ::-webkit-scrollbar-thumb:hover {
            background: ${CONSTS.colors.greyDark};
        }
    }
`
const mapStateToProps = (state: AppState) => ({
    currentCategory: getCategory(state.categories.items,state.categories.menuCategoryId),
    currentCategoryId: state.categories.currentCategoryId,
    isSubCategoriesOpen: state.categories.isSubCategoriesOpen,
});
  
const mapDispatchToProps = (dispatch:any) => {
    return {
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SubCategoires);

// export default SubCategoires;